import axios from 'axios'

export default {
  getOnlineUsers(params) {
    return axios.get(`/dash/usuariosOnline/${params.identity}`)
  },
  getCharts(params) {
    return axios.get(`/dash/graficos/${params.identity}`, { params })
  },
  getLastConnections(params) {
    return axios.get(`/dash/ultimasConexoes/${params.identity}`)
  }
}
